export default (message) => [`%c-------KK-ERROR-------
${message}
------------------------`, `color: #608be6;`];
